import React, { useState, useEffect, useContext } from 'react'

import { timespanFromTimestamps, getTreeItem } from '../utils/RefreshFunctions'
import { initialRunReferenceState, initialCheckState, SpanPickerContext } from '../utils/initialStates'
import OperationsCheck from './Check'
import OperationsAutoLoader from './AutoLoader'

/**
 * It returns the last run or last section of a specific intervention, given all the keys on the three
 * @param allKeys {Key[]}
 * @param item {"Run (", "Section ("}
 * @parm interventionId { number } - it sepecifies an intervention
 * @returns string[]
 */

export const getLastItem = (allKeys: string[], item: 'Run (' | 'Section (', interventionId: string): string[] => {
    let allItems = allKeys.filter(e => e.startsWith(item + interventionId + ','))
    return [allItems[allItems.length - 1]]
}

/**
 * This component works the selection of items on the tree.
 * @param tree {TreeComponentProps} - data related to the tree (the items on the tree, an array of keys to all the items, the default expanded nodes)
 * @returns {JSX.Element} - a child that will return a JSX Element
 */

const OperationsSelect = ({ tree }: { tree: TreeComponentProps }): JSX.Element => {
    const [selectedKey, setSelectedKey] = useState<string[]>([])
    const [selectedTimespan, setSelectedTimespan] = useState('')
    const [selectedRunReference, setSelectedRunReference] = useState<runReferenceProps>(initialRunReferenceState)
    const { operationsPickerConfigs } = useContext(SpanPickerContext)

    useEffect(() => {
        if (operationsPickerConfigs.autoSelectLastRun)
            setSelectedKey(getLastItem(tree.allKeys, 'Run (', tree.formattedTree[0].id))
    }, [JSON.stringify(tree.allKeys)])

    useEffect(() => {
        if (selectedKey.length > 0) {
            let treeItem = getTreeItem(selectedKey, tree.formattedTree)
            setSelectedTimespan(timespanFromTimestamps(treeItem.start_timestamp, treeItem.end_timestamp, false))
            setSelectedRunReference(treeItem.runReference)
        }
    }, [selectedKey])

    const onSelect = (selectedKeyOnClick: any): void => {
        if (/^Operation|^Run/.test(selectedKeyOnClick)) setSelectedKey(selectedKeyOnClick)
    }

    return operationsPickerConfigs.enableChecking ? (
        <OperationsCheck
            tree={tree}
            select={{
                selectedKey: selectedKey,
                onSelect: onSelect,
                selectedTimespan: selectedTimespan,
                selectedRunReference: selectedRunReference
            }}
        />
    ) : (
        <OperationsAutoLoader
            tree={tree}
            select={{
                selectedKey: selectedKey,
                onSelect: onSelect,
                selectedTimespan: selectedTimespan,
                selectedRunReference: selectedRunReference
            }}
            check={initialCheckState}
        />
    )
}

export default OperationsSelect
